export const GET_LESSONS = 'lessons/GET_LESSONS';
export const UPDATE_LESSON_BY_ID = 'lessons/UPDATE_LESSON_BY_ID';
export const REMOVE_LESSON_BY_ID = 'lessons/REMOVE_LESSON_BY_ID';
